export default __webpack_public_path__ + "static/media/12.e63f08bd.svg";